import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const PaperPlane: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path d="M41.55 12.725l.268-.038-.193.258-.076-.22zM26.715 32.871L13.72 23.355l27.212-9.484-14.215 19zm-13.729 1.905V24.43l7.735 5.663-7.735 4.683zm-6.845-16.97l33.23-4.769-26.927 9.385-6.303-4.616zm-3.34-.834l8.886 6.506v13.604l10.17-6.158 5.128 3.756 17.752-23.726-41.936 6.018z" />
  );

  const normalHover = (
    <path d="M43.55 10.725l.268-.038-.193.258-.076-.22zM28.715 30.871L15.72 21.355l27.212-9.484-14.215 19zm-13.729 1.905V22.43l7.735 5.663-7.735 4.683zm-6.845-16.97l33.23-4.769-26.927 9.385-6.303-4.616zm-3.34-.834l8.886 6.506v13.604l10.17-6.158 5.128 3.756L46.738 8.954 4.802 14.972z" />
  );

  const xSmall = (
    <path d="M41.42 12.603l.244-.035-.174.234-.07-.199zM26.583 32.725L13.61 23.226l27.163-9.467-14.19 18.966zm-13.716 1.903v-10.31l7.706 5.644-7.706 4.666zM6.036 17.68l33.108-4.75-26.828 9.35-6.28-4.6zm-3.392-.846l8.902 6.517V36.97l10.18-6.163 5.132 3.756L44.629 10.81 2.644 16.834z" />
  );

  const xSmallHover = (
    <path d="M45.21 8.814l.244-.036-.174.234-.07-.198zM30.372 28.936l-12.973-9.499L44.562 9.97l-14.19 18.966zm-13.717 1.902v-10.31l7.707 5.644-7.707 4.666zM9.825 13.89l33.109-4.75-26.828 9.35-6.28-4.6zm-3.391-.846l8.901 6.518V33.18l10.18-6.163 5.132 3.757L48.418 7.02 6.434 13.044z" />
  );

  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover });
};

export default PaperPlane;
